<template>
  <article class="customer-wrapper">
    <div class="container">
      <p>개인의 자율성과 경험을 극대화 시키는 <br />학습 설계 & 맞춤 교육</p>
      <p>
        <span>23년</span> 동안 글로벌 역량의<br /><span>場</span>을 만들어,<br />현재
        <span>500여</span> 고객사와 함께 하고 있습니다.
      </p>
    </div>
  </article>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.customer-wrapper {
  position: relative;
  padding: 40px 0;
  color: #232323;
  text-align: center;
  background: url(~@/assets/img/newGlobal/main/customer/bg.jpg) repeat-x center/
    cover;
  animation: 50s marquee infinite linear;

  p:nth-child(1) {
    font-size: 16px;
    margin-bottom: 34px;
  }

  p:nth-child(2) {
    font-size: 34px;

    span {
      font-weight: bold;
    }
  }
}

@media screen and (min-width: 1350px) {
  .customer-wrapper {
    padding: 80px 0;

    p:nth-child(1) {
      font-size: 18px;

      br {
        display: none;
      }
    }

    p:nth-child(2) {
      font-size: 50px;
    }
  }
}

@keyframes marquee {
  0% {
    background-position-x: 0%;
  }

  100% {
    background-position-x: 100%;
  }
}
</style>
